<div class="dialog-container">
  <lib-dialog-header (closeClick)="cancelClicked()" i18n> Export to CSV </lib-dialog-header>
  <div class="dialog-content">
    <div class="mb-3 pb-3" i18n>
      Which table columns would you like included in the report? Any filters and/or searches applied to the table will
      be respected in the export.
    </div>
    <lib-select-all-checkbox-form-field [childCheckboxFormControls]="tableColumnFormControls()"></lib-select-all-checkbox-form-field>
    <div class="ms-4 mt-4 d-flex flex-column gap-4">
      @for (column of tableColumnSelectors(); track $index) {
        <lib-checkbox-form-field [formControl]="column.formControl" [label]="column.tableColumn.title ?? ''"></lib-checkbox-form-field>
      }
    </div>
  </div>
  <div class="dialog-footer">
    <lib-button [type]="ButtonType.secondary" (buttonClick)="cancelClicked()" i18n> Cancel </lib-button>
    <lib-button
      [type]="ButtonType.primary"
      [loading]="loading()"
      (buttonClick)="exportClicked()"
      i18n>
      Export
    </lib-button>
  </div>
</div>
